import { noun } from 'plural-ru';
import React from 'react';

import { Text } from '../../uikit';

export type ThreeForms = [string, string, string];

interface ITotalCountProps {
    totalCount: number;
    forms?: ThreeForms;
    prefix?: string;
    className?: string;
}

const defaultForms = ['запись', 'записи', 'записей'] as ThreeForms;

export const TotalCount = ({ totalCount, forms = defaultForms, prefix = '', className }: ITotalCountProps) => (
    <Text view="secondary" size="s" className={className}>
        {totalCount ? `${prefix} ${totalCount} ${noun(totalCount, ...forms)}` : '0 записей из 0'}
    </Text>
);

TotalCount.displayName = 'TotalCount';
